module.exports = __webpack_public_path__ + "img/merry.d75d9a0b.jpg";